import { render } from "./scope.component.vue?vue&type=template&id=0b81116e&scoped=true&ts=true"
import script from "./scope.component.vue?vue&type=script&lang=ts"
export * from "./scope.component.vue?vue&type=script&lang=ts"

import "./scope.component.vue?vue&type=style&index=0&id=0b81116e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b81116e"]])

export default __exports__